const popData = cb => {
  $.getScript('https://calliecalculator.com/pop-data-2.js', () => {
    cb();
  });
};

export default popData;
